export default __webpack_public_path__ + "static/media/Force8.ea190f6f.png";